import { RelatedPartType } from '@/entities/RelatedPartType';

// Quick search
export const QUICK_SEARCH = {
    SEARCH_TERM_PLACEHOLDER: 'Formula.QuickSearch.SearchTermPlaceholder',
    SEARCH_BUTTON_ALT_TEXT: 'Formula.QuickSearch.SearchButtonAltText',
};

// Quick search result
export const QUICK_SEARCH_RESULT = {
    TITLE: 'Formula.QuickSearchResult.Title',
    CLOSE_BUTTON: 'Formula.QuickSearchResult.CloseButton',
    PART_NUMBER: 'Formula.QuickSearchResult.PartNumber',
    DESCRIPTION: 'Formula.QuickSearchResult.Description',
    BRAND: 'Formula.QuickSearchResult.Brand',
    PRICE: 'Formula.QuickSearchResult.Price',
    AVAILABILITY: 'Formula.QuickSearchResult.Availability',
    NO_RESULTS_FOUND: 'Formula.QuickSearchResult.NoResultsFound',
    LINK_TO_DETAIL_SEARCH_TEXT: 'Formula.QuickSearchResult.LinkToDetailSearchText',
    LINK_TO_PARTS_CATALOGUE_SEARCH_TEXT: 'Formula.QuickSearchResult.LinkToPartsCatalogueSearchText',
};

// VIN search
export const VIN_SEARCH = {
    SEARCH_TERM_PLACEHOLDER: 'Formula.VinSearch.SearchTermPlaceholder',
    SEARCH_BUTTON_ALT_TEXT: 'Formula.VinSearch.SearchButtonAltText',
};

// VIN search result
export const VIN_SEARCH_RESULT = {
    TITLE: 'Formula.VinSearchResult.Title',
    CLOSE_BUTTON: 'Formula.VinSearchResult.CloseButton',
    NO_RESULTS_FOUND: 'Formula.VinSearchResult.NoResultsFound',
    LINK_TO_PARTS_CATALOGUE_SEARCH_TEXT: QUICK_SEARCH_RESULT.LINK_TO_PARTS_CATALOGUE_SEARCH_TEXT,
};

export const DELIVERY_TIME_TOOLTIP = {
    HEADER_TEXT: 'Formula.DeliveryTimeTooltip.HeaderText',
    EACH_TEXT: 'Formula.DeliveryTimeTooltip.EachText',
};

export const DEPOSIT_PART_INFO_TOOLTIP = {
    INFO_TEXT: 'Formula.DepositPartInfoTooltip.InfoText',
};

// Orders
export const ORDER_ITEM_STATE_TOOLTIP = {
    HEADER_TEXT: 'Formula.OrderItemStateTooltip.HeaderText',
    READY_FOR_PICKING_TEXT: 'Formula.OrderItemStateTooltip.ReadyForPickingTextText',
    READY_FOR_SHIPMENT_TEXT: 'Formula.OrderItemStateTooltip.ReadyForShipmentText',
    QUANTITY_INVOICED_TEXT: 'Formula.OrderItemStateTooltip.QuantityInvoicedText',
    IN_ORDER_TEXT: 'Formula.OrderItemStateTooltip.InOrderText',
};

// Price
export const PRICE = {
    NET: 'Formula.Price.Net',
    GROSS: 'Formula.Price.Gross',
    NETTEXTUAL: 'Formula.Price.NetTextual',
    GROSSTEXTUAL: 'Formula.Price.GrossTextual',
    HIDDEN: 'Formula.Price.Hidden',
};

// Part
export const PART = {
    ALTERNATIVES_AND_REPLACEMENTS: 'Formula.Part.AlternativesAndReplacements',
    SHOW_REPLACEMENTS_BUTTON_TEXT: 'Formula.Part.ShowReplacementsButtonText',
    DELIVERY_TEXT: {
        IN_STOCK: 'Formula.Part.DeliveryText.InStock',
    },
    UNIT_CODE_TEXT: {
        For(key: string): string {
            return `Formula.Part.UnitCode.${key}`;
        },
        UNKNOWN: 'Formula.Part.UnitCode.Unknown',
    },
    ForRelation(relatedPartType: RelatedPartType): string {
        switch (relatedPartType) {
            case RelatedPartType.Alternative:
                return 'Formula.Part.Alternative';
            case RelatedPartType.Replacement:
                return 'Formula.Part.Replacement';
            case RelatedPartType.ChildBrandPart:
                return 'Formula.Part.ChildBrand';
            default:
                return '';
        }
    },
};

// Part details
export const PART_DETAILS = {
    QUANTITY: 'Formula.PartDetails.Quantity',
    ADD_TO_CART: 'Formula.PartDetails.AddToCart',
};

// Shopping cart overview
export const SHOPPING_CART_OVERVIEW = {
    SHOPPING_CART: 'Formula.ShoppingCartOverview.ShoppingCart',
    CART_NAME: 'Formula.ShoppingCartOverview.CartName',
    ORDER_NAME: 'Formula.ShoppingCartOverview.OrderName',
    PART_NUMBER: 'Formula.ShoppingCartOverview.PartNumber',
    DESCRIPTION: 'Formula.ShoppingCartOverview.Description',
    BRAND: 'Formula.ShoppingCartOverview.Brand',
    SHIPPING: 'Formula.ShoppingCartOverview.Shipping',
    ORDER_METHOD: 'Formula.ShoppingCartOverview.OrderMethod',
    DELIVERY: 'Formula.ShoppingCartOverview.Delivery',
    USER_INFO_TEXT: 'Formula.ShoppingCartOverview.UserInfoText',
    PRICE: 'Formula.ShoppingCartOverview.Price',
    QUANTITY: 'Formula.ShoppingCartOverview.Quantity',
    GO_TO_SUMMARY: 'Formula.ShoppingCartOverview.Button.GoToSummary',
    CONTINUE_SHOPPING: 'Formula.ShoppingCartOverview.Button.ContinueShopping',
    SAVE: 'Formula.ShoppingCartOverview.Button.Save',
    EMPTY_CART: 'Formula.ShoppingCartOverview.EmptyCart',
    ERROR_MUST_NOT_BE_EMPTY: 'Formula.ShoppingCartOverview.Error.MustNotBeEmpty',
    MOVE_CART_ITEM_DEFAULT_OPTION: 'Formula.ShoppingCartOverview.MoveCartItemDefaultOption',
};

// Shipping methods
export const SHIPPING = {
    SHIPPING_METHOD_VALUE: {
        For(key: string): string {
            return `Formula.ShippingMethod.${key}`;
        },
    },
};

// Order methods
export const ORDER_METHOD = {
    For(key: string): string {
        return `Formula.OrderMethod.${key}`;
    },
};

// Country
export const COUNTRY = {
    For(key: string): string {
        return `Formula.Country.${key}`;
    },
};

// State
export const STATE = {
    For(key: string): string {
        return `Formula.State.${key}`;
    },
};

// Availability
export const AVAILABILITY = {
    UNKNOWN: 'Formula.Availability.Unknown',
    NOT_IN_STOCK: 'Formula.Availability.NotInStock',
    For(key: string): string {
        return `Formula.Availability.${key}`;
    },
};

// Shopping cart
export const SHOPPING_CART = {
    ADD_SUCCESS: 'Formula.ShoppingCart.AddSuccess',
    ADD_FAILED: 'Formula.ShoppingCart.AddFailed',
    ADD_BULK_SUCCESS: 'Formula.ShoppingCart.AddBulkSuccess',
    ADD_BULK_FAILED: 'Formula.ShoppingCart.AddBulkFailed',
    MOVE_ITEM_SUCCESS: 'Formula.ShoppingCart.MoveItemSuccess',
    MOVE_ITEM_FAILED: 'Formula.ShoppingCart.MoveItemFailed',
    CREATE_NEW_CART_SUCCESS: 'Formula.ShoppingCart.CreateNewCartSuccess',
    CREATE_NEW_CART_FAILED: 'Formula.ShoppingCart.CreateNewCartFailed',
    DELETE_CART_SUCCESS: 'Formula.ShoppingCart.DeleteCartSuccess',
    DELETE_CART_FAILED: 'Formula.ShoppingCart.DeleteCartFailed',
};

// Shopping cart upload
export const SHOPPING_CART_UPLOAD = {
    TITLE: 'Formula.Titles.ShoppingCartUpload',
    DESCRIPTION: 'Formula.ShoppingCartUpload.Description',
    DEMO_FILE_DOWNLOAD_TEXT: 'Formula.ShoppingCartUpload.DemoFileDownloadText',
    DEMO_FILE_DOWNLOAD_TEXT_EXCEL: 'Formula.ShoppingCartUpload.DemoFileDownloadTextExcel',
    UPLOAD_FILE: 'Formula.ShoppingCartUpload.UploadFileButton',
    SHOW_USED_PARTS: 'Formula.ShoppingCartUpload.ShowUsedParts',
    ADD_TO_NEW_CART: 'Formula.ShoppingCartUpload.AddToNewCartButton',
    ADD_TO_EXISTING_CART: 'Formula.ShoppingCartUpload.AddToExistingCartButton',
    SELECT_CART: 'Formula.ShoppingCartUpload.SelectCartText',
    LINES_PARSED: 'Formula.ShoppingCartUpload.LinesParsed',
    SUM_SELECTED_ITEMS: 'Formula.ShoppingCartUpload.SumSelectedItems',
    FOUND_PARTS: 'Formula.ShoppingCartUpload.FoundParts',
    FOUND_PARTS_DESCRIPTION: 'Formula.ShoppingCartUpload.FoundPartsDescription',
    REPLACED_PARTS: 'Formula.ShoppingCartUpload.ReplacedParts',
    REPLACED_PARTS_DESCRIPTION: 'Formula.ShoppingCartUpload.ReplacedPartsDescription',
    USED_PARTS: 'Formula.ShoppingCartUpload.UsedParts',
    USED_PARTS_DESCRIPTION: 'Formula.ShoppingCartUpload.UsedPartsDescription',
    NOT_FOUND_PARTS: 'Formula.ShoppingCartUpload.NotFoundParts',
    NOT_FOUND_PARTS_DESCRIPTION: 'Formula.ShoppingCartUpload.NotFoundPartsDescription',
    PROGRESS: 'Formula.ShoppingCartUpload.Progress',
    PROGRESS_UNDEFINED: 'Formula.ShoppingCartUpload.ProgressUndefined',
    GENERAL_ERROR: 'Formula.ShoppingCartUpload.GeneralError',

    RESULT: {
        PART_NUMBER: SHOPPING_CART_OVERVIEW.PART_NUMBER,
        DESCRIPTION: SHOPPING_CART_OVERVIEW.DESCRIPTION,
        BRAND: SHOPPING_CART_OVERVIEW.BRAND,
        QUANTITY: SHOPPING_CART_OVERVIEW.QUANTITY,
        INFO_TEXT: SHOPPING_CART_OVERVIEW.USER_INFO_TEXT,
        REPLACED_BY: 'Formula.ShoppingCartUpload.Result.ReplacedBy',
        DELIVERY: SHOPPING_CART_OVERVIEW.DELIVERY,
        PRICE: SHOPPING_CART_OVERVIEW.PRICE,
        SUM: 'Formula.ShoppingCartUpload.Result.Sum',
        DOWNLOAD: 'Formula.ShoppingCartUpload.Result.Download',
    },
};

// Shopping cart menu
export const SHOPPING_CART_MENU = {
    TITLE: 'Formula.ShoppingCartMenu.Title',
    GO_TO_CART: 'Formula.ShoppingCartMenu.GoToCart',
    NUMBER_OF_SHOPPING_CARTS: 'Formula.ShoppingCartMenu.NumberOfShoppingCarts',
    DIRECT_INPUT_TITLE: 'Formula.ShoppingCartMenu.DirectInputTitle',
    DIRECT_INPUT_PLACEHOLDER: 'Formula.ShoppingCartMenu.DirectInputPlaceholder',
};

export const ORDERS_FOR_USER = {
    TITLE: 'Formula.OrdersForUser.Title',
    FILTER_PLACEHOLDER: 'Formula.OrdersForUser.Filter_Placeholder',
    FILTER_CLEAR: 'Formula.OrdersForUser.Filter_Clear',
};

export const ORDERS_FOR_USER_TABLE = {
    COL_REFERENCE: 'Formula.OrdersForUserTable.Col_Reference',
    COL_NUMBER: 'Formula.OrdersForUserTable.Col_Number',
    COL_DATE: 'Formula.OrdersForUserTable.Col_Date',
    COL_STATUS: 'Formula.OrdersForUserTable.Col_Status',
    COL_TOTAL_AMOUNT: 'Formula.OrdersForUserTable.Col_Total_Amount',
    COL_ITEMS: 'Formula.OrdersForUserTable.Col_Items',
    COL_SHOW_DETAILS: 'Formula.OrdersForUserTable.Col_Show_Details',
    COL_HIDE_DETAILS: 'Formula.OrdersForUserTable.Col_Hide_Details',
    COL_DETAIL_PART_NUMBER: 'Formula.OrdersForUserTable.Col_Detail_Part_Number',
    COL_DETAIL_DESCRIPTION: 'Formula.OrdersForUserTable.Col_Detail_Description',
    COL_DETAIL_MAKE: 'Formula.OrdersForUserTable.Col_Detail_Make',
    COL_DETAIL_ADDITIONAL_INFO: 'Formula.OrdersForUserTable.Col_Detail_Additional_Info',
    COL_DETAIL_QUANTITY: 'Formula.OrdersForUserTable.Col_Detail_Quantity',
    COL_DETAIL_DELIVERED_QUANTITY: 'Formula.OrdersForUserTable.Col_Detail_Delivered_Quantity',
    COL_DETAIL_AMOUNT: 'Formula.OrdersForUserTable.Col_Detail_Amount',
};

// Availability clock
export const AVAILABILITY_CLOCK = {
    COUNTDOWN_TEXT: 'Formula.AvailabilityClock.CountdownText',
    SHIPPING_WITHIN_TEXT: 'Formula.AvailabilityClock.ShippingWithinText',
    DAYS: 'Formula.AvailabilityClock.Days',
    HOURS: 'Formula.AvailabilityClock.Hours',
    MINUTES: 'Formula.AvailabilityClock.Minutes',
    SECONDS: 'Formula.AvailabilityClock.Seconds',
};

export const PART_SEARCH = {
    RESULTS_HEADING: 'Formula.PartSearch.ResultsHeading',
    SEARCH_BOX_TITLE: 'Formula.PartSearch.SearchBoxTitle',
    ADDITIONAL_PARTS_LINK_TEXT: 'Formula.PartSearch.AdditionalPartsLink',
};

export const CATALOGUE_SEARCH = {
    RESULTS_HEADING: 'Formula.CatalogueSearch.ResultsHeading',
    SUB_HEADLINE_BRAND: 'Formula.CatalogueSearch.SubHeadline.Brand',
    SUB_HEADLINE_MODEL_GROUP: 'Formula.CatalogueSearch.SubHeadline.ModelGroup',
    SUB_HEADLINE_MODEL: 'Formula.CatalogueSearch.SubHeadline.Model',
    SUB_HEADLINE_DIAGRAM: 'Formula.CatalogueSearch.SubHeadline.Diagram',
    SUB_HEADLINE_VIN: 'Formula.CatalogueSearch.SubHeadline.Vin',
};

export const PART_CATEGORIES = {
    For(categoryName: string): string {
        return `Formula.PartCategories.${categoryName}`;
    },
};

// Cookie disclaimer
export const COOKIE_DISCLAIMER = {
    BUTTON_TEXT: 'Formula.CookieDisclaimer.ButtonText',
    MESSAGE: 'Formula.CookieDisclaimer.Message',
    MORE_INFO_BUTTON_TEXT: 'Formula.CookieDisclaimer.MoreInfoButtonText',
};

export const PART_CATALOGUE = {
    TITLE_TEXT: 'Formula.PartCatalogue.TitleText',
    GO_TO_GRAPHIC_TEXT: 'Formula.PartCatalogue.GoToGraphicText',
    CHANGE_SELECTION: 'Formula.PartCatalogue.ChangeSelection',
    BREADCRUMB_DESCRIPTION_TEXT: 'Formula.PartCatalogue.BreadcrumbDescriptionText',
    BACK_BUTTON_TEXT: 'Formula.PartCatalogue.BackButtonText',

    META: {
        ASSEMBLY_NUMBER_FROM: 'Formula.PartCatalogue.Meta.AssemblyNumberFrom',
        ASSEMBLY_NUMBER_TO: 'Formula.PartCatalogue.Meta.AssemblyNumberTo',
        COLOR: 'Formula.PartCatalogue.Meta.Color',
        ENGINE_NUMBER_FROM: 'Formula.PartCatalogue.Meta.EngineNumberFrom',
        ENGINE_NUMBER_TO: 'Formula.PartCatalogue.Meta.EngineNumberTo',
        SIDE: 'Formula.PartCatalogue.Meta.Side',
        VIN_FROM: 'Formula.PartCatalogue.Meta.VinFrom',
        VIN_TO: 'Formula.PartCatalogue.Meta.VinTo',
    },
};

export const CAR = {
    AVAILABLE_PARTS_TITLE: 'Formula.Car.AvailablePartsTitle',
    RANDOM_PARTS_TITLE: 'Formula.Car.RandomPartsTitle',
    SEARCH_FOR_PARTS: 'Formula.Car.SearchForParts',
    PARTS: 'Formula.Car.Parts',
};
